import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { Row, Col } from "react-bootstrap";
import { Card, CardBody, CardHeader } from "reactstrap";
import "../../CSS/configuracion.css";
import api from "../../Component/axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
library.add(fab, fas, far);
const MySwal = withReactContent(Swal);

const validateInput = (inputValue) => {
  const nonAlphabetPattern = /^[^a-zA-Z]*$/;
  return nonAlphabetPattern.test(inputValue);
};

const Tarima = () => {
  const [tarimaList, setTarimaList] = useState([]);
  const [tarima, setTarima] = useState("");
  const token = localStorage.getItem("@Token");

  const getTariam = () => {
    api
      .get("api/empaque/tarimas/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + token,
        },
      })
      .then((response) => {
        setTarimaList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const insertNewTarima = () => {
    if (tarima === "" || validateInput(tarima)) {
      MySwal.fire({
        icon: "info",
        title: "Favor de llenar todos los campos",
        timer: 1500,
      });
      return;
    }

    api
      .post(
        "api/empaque/tarimas/",
        { data: tarima },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
        }
      )
      .then((response) => {
        MySwal.fire({
          icon: "success",
          title: "Datos guardados",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        if (error.response.status === 400) {
          MySwal.fire({
            icon: "error",
            title: error.response.data.msg,
          });
        } else {
          MySwal.fire({
            icon: "error",
            title: error,
            text: "Favor de contactar con el equipo de desarrollo para solucionar el problema",
          });
        }
      })
      .finally(() => {
        setTarima("");
        getTariam();
      });
  };

  const editTarima = (id_tarima) => {
    const selected_tarima = tarimaList.find(
      (item) => item.idtarima === id_tarima
    );
    MySwal.fire({
      title: "Modificar tarima",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
        value: selected_tarima.tarima,
      },
      showCancelButton: true,
      confirmButtonText: "Guardar",
      showLoaderOnConfirm: true,
      preConfirm: async (tarima) => {
        try {
          if (tarima === "" || validateInput(tarima)) {
            throw new Error("Favor de llenar los campos");
          }
          const response = await api.put(
            "api/empaque/tarimas/",
            {
              data: {
                idtarima: id_tarima,
                tarima: tarima,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Token " + token,
              },
            }
          );
          return response;
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Datos guardados",
        });
        setTarima("");
        getTariam();
      }
    });
  };

  const deleteTarima = (id_tarima, estatus) => {
    const action = estatus === 0 ? "activar" : "desactivar";
    const responseText = estatus === 0 ? "activado" : "desactivado";
    MySwal.fire({
      icon: "warning",
      title: `¿Seguro que desea ${action} el tarima?`,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: estatus === 0 ? "Activar" : "Desactivar",
      confirmButtonColor: estatus === 0 ? "#28a745" : "#dc3545",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      backdrop: true,
      preConfirm: async () => {
        try {
          const response = await api.delete(
            `api/empaque/tarimas/?id_tarima=${id_tarima}&estatus=${
              estatus === 1 ? 0 : 1
            }`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Token " + token,
              },
            }
          );
          return response;
        } catch (error) {
          Swal.showValidationMessage("Error - Algo salió mal!");
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        getTariam();
        MySwal.fire({
          icon: "success",
          title: `Registro ${responseText}`,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  };

  useEffect(() => {
    getTariam();
  }, []);

  return (
    <Card className="my-2" style={{ height: "90vh" }}>
      <CardHeader style={{ fontWeight: "bold", textAlign: "center" }}>
        Configurar Tarima
      </CardHeader>
      <CardBody>
        <Row>
          <Col md={3} xs={12} sm={12} lg={3}>
            <input
              className="form-control"
              value={tarima}
              onChange={(e) => setTarima(e.target.value)}
              placeholder="Tarima"
            />
          </Col>
          <Col md={3} xs={12} sm={12} lg={3} className="d-grid">
            <button
              className="btn btn-primary"
              onClick={() => insertNewTarima()}
            >
              <i>
                <FontAwesomeIcon icon="fa-solid fa-plus" />
              </i>{" "}
              Agregar
            </button>
          </Col>
        </Row>
        <br />
        <Row>
          <Col style={{ overflow: "auto", height: "70vh" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Tarima</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {tarimaList.map((item, i) => (
                  <tr key={item.idtarima}>
                    <th>{item.tarima}</th>
                    <td>
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => editTarima(item.idtarima)}
                      >
                        <FontAwesomeIcon icon="fa-solid fa-pencil" />
                      </button>{" "}
                      <button
                        className={
                          item.estatus === 1
                            ? "btn btn-outline-danger"
                            : "btn btn-outline-success"
                        }
                        onClick={() =>
                          deleteTarima(item.idtarima, item.estatus)
                        }
                      >
                        <FontAwesomeIcon icon="fas fa-power-off" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default Tarima;
